var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex d-flex-c not-found"},[_c('span',{staticClass:"title mt-2 mb-1"},[_vm._v("Houston, We have a problem!")]),_c('span',{staticClass:"description"},[_vm._v("We could not locate the page you were looking for."),_c('br'),_vm._v(" Head back to the "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("dashboard")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }